module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions/left-table-466f1485bc0ad89046e3aa6643f3dd5b.png";